// extracted by mini-css-extract-plugin
module.exports = {"mobile_drag":"VerticalTabs_mobile_drag__TSpOq","nav":"VerticalTabs_nav__78mXu","card":"VerticalTabs_card__J3XdC","title":"VerticalTabs_title__3hIUX"};